/**
 * Source: ftp://ftp.unicode.org/Public/UCD/latest/ucd/SpecialCasing.txt
 */
var SUPPORTED_LOCALE = {
  tr: {
    regexp: /[\u0069]/g,
    map: {
      i: "\u0130"
    }
  },
  az: {
    regexp: /[\u0069]/g,
    map: {
      i: "\u0130"
    }
  },
  lt: {
    regexp: /[\u0069\u006A\u012F]\u0307|\u0069\u0307[\u0300\u0301\u0303]/g,
    map: {
      i̇: "I",
      j̇: "J",
      į̇: "\u012E",
      i̇̀: "\xCC",
      i̇́: "\xCD",
      i̇̃: "\u0128"
    }
  }
};
/**
 * Localized upper case.
 */

export function localeUpperCase(str, locale) {
  var lang = SUPPORTED_LOCALE[locale.toLowerCase()];
  if (lang) return upperCase(str.replace(lang.regexp, function (m) {
    return lang.map[m];
  }));
  return upperCase(str);
}
/**
 * Upper case as a function.
 */

export function upperCase(str) {
  return str.toUpperCase();
}